import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InteractionComponent} from './interaction.component';
import {SharedModule} from '../shared/shared.module';

@NgModule({
    declarations: [InteractionComponent],
    imports: [
        CommonModule,
        SharedModule
    ],
    exports: [
        InteractionComponent
    ]
})
export class InteractionModule {}
